import HttpClient from "@/common/boot/HttpClient"

const listarDisponibilidades = async ({ commit }, payload) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.post(
      `ctrl-disponibilidade/visualizar`,
      payload
    )
    commit('LISTAR_DADOS', response.data.data.data)
    commit('ATUALIZAR_PAGINACAO', response.data.data)
    return response
  } catch (error) {
    console.error('Erro ao listar disponibilidades:', error)
    commit('LISTAR_DADOS', [])
    commit('ATUALIZAR_PAGINACAO', null)
  } finally {
    commit('CARREGANDO', false)
  }
}

const salvarDisponibilidade = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.post('/ctrl-disponibilidade', payload)
    await dispatch('listarDisponibilidades', { page: 1, current_page: 1, per_page: 20 })
    return response
  } catch (error) {
    console.error('Erro ao salvar disponibilidade:', error)
    throw error
  } finally {
    commit('CARREGANDO', false)
  }
}

const atualizarDisponibilidade = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.put(`/ctrl-disponibilidade/${payload.id}`, payload)
    await dispatch('listarDisponibilidades', { page: 1, current_page: 1, per_page: 20 })
    return response
  } catch (error) {
    console.error('Erro ao atualizar disponibilidade:', error)
    throw error
  } finally {
    commit('CARREGANDO', false)
  }
}

const importarDisponibilidades = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.post('/ctrl-disponibilidade/importar', payload.formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    await dispatch('listarDisponibilidades', { page: 1, current_page: 1, per_page: 20 })
    return response
  } catch (error) {
    console.error('Erro ao importar disponibilidades:', error)
    throw error
  } finally {
    commit('CARREGANDO', false)
  }
}

const sincronizarProvedores = async ({ commit, dispatch }, id) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.post(`/ctrl-disponibilidade/${id}/sincronizar-provedores`)
    await dispatch('listarDisponibilidades', { page: 1, current_page: 1, per_page: 20 })
    return response
  } catch (error) {
    console.error('Erro ao sincronizar provedores:', error)
    throw error
  } finally {
    commit('CARREGANDO', false)
  }
}

const listarProvedores = async ({ commit }) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.get('/ctrl-provedores')
    commit('INSERIR_LISTA_PROVEDORES', response.data.data || [])
    return response
  } catch (error) {
    console.error('Erro ao listar provedores:', error)
    commit('INSERIR_LISTA_PROVEDORES', [])
    throw error
  } finally {
    commit('CARREGANDO', false)
  }
}

const recuperarDisponibilidadeComProvedores = async ({ commit }, payload) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.get(`/ctrl-disponibilidade/${payload}/provedores`)
    commit('INSERIR_DISPONIBILIDADE_SELECIONADA', response.data.data)
    return response
  } catch (error) {
    console.error('Erro ao recuperar disponibilidade com provedores:', error)
    throw error
  } finally {
    commit('CARREGANDO', false)
  }
}

const associarProvedoresADisponibilidade = async ({ commit }, payload) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.post(`/ctrl-disponibilidade/${payload.disponibilidadeId}/sincronizar-provedores`, payload)
    return response
  } catch (error) {
    console.error('Erro ao associar provedores à disponibilidade:', error)
    throw error
  } finally {
    commit('CARREGANDO', false)
  }
}

export {
  listarDisponibilidades,
  salvarDisponibilidade,
  atualizarDisponibilidade,
  importarDisponibilidades,
  sincronizarProvedores,
  listarProvedores,
  recuperarDisponibilidadeComProvedores,
  associarProvedoresADisponibilidade
}

